"use strict";
Object.defineProperty(exports, "__esModule", { value: !0 });
var browserMiddleware = require("./_chunks-cjs/browserMiddleware.cjs"), getIt = require("get-it");
function defineDeprecatedCreateClient(createClient2) {
  return function(config) {
    return browserMiddleware.printNoDefaultExport(), createClient2(config);
  };
}
const exp = browserMiddleware.defineCreateClientExports(browserMiddleware.envMiddleware, browserMiddleware.SanityClient), requester = exp.requester, createClient = exp.createClient, deprecatedCreateClient = defineDeprecatedCreateClient(createClient);
exports.BasePatch = browserMiddleware.BasePatch;
exports.BaseTransaction = browserMiddleware.BaseTransaction;
exports.ClientError = browserMiddleware.ClientError;
exports.ObservablePatch = browserMiddleware.ObservablePatch;
exports.ObservableSanityClient = browserMiddleware.ObservableSanityClient;
exports.ObservableTransaction = browserMiddleware.ObservableTransaction;
exports.Patch = browserMiddleware.Patch;
exports.SanityClient = browserMiddleware.SanityClient;
exports.ServerError = browserMiddleware.ServerError;
exports.Transaction = browserMiddleware.Transaction;
Object.defineProperty(exports, "unstable__adapter", {
  enumerable: !0,
  get: function() {
    return getIt.adapter;
  }
});
Object.defineProperty(exports, "unstable__environment", {
  enumerable: !0,
  get: function() {
    return getIt.environment;
  }
});
exports.createClient = createClient;
exports.default = deprecatedCreateClient;
exports.requester = requester;
//# sourceMappingURL=index.browser.cjs.map
